import { render, staticRenderFns } from "./IgPaymentClientInfoForm.vue?vue&type=template&id=4d9d9299&"
import script from "./IgPaymentClientInfoForm.vue?vue&type=script&lang=js&"
export * from "./IgPaymentClientInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports